const Config = {
  urls: {
    aryaCalendar: 'https://calendar-qa.goarya.com',
    aryaConnectNotifications: 'https://connectapi-qa.goarya.com/hubs/connect',
    aryaConnect: 'https://connectapi-qa.goarya.com/api/v1',
    getWhiteLabelResourceUrl: client => `https://arya3-whitelabel.s3.amazonaws.com/${client.toLowerCase()}-qa`,
    aryaUrl: 'https://app-qa.goarya.com',
  },
};

export default Config;
